module.exports = __webpack_public_path__ + "img/grid-2.96e77e8d.svg";